module.exports = __webpack_public_path__ + "img/logo-big-white.797fb68c.svg";